import { render } from "./bingtu.vue?vue&type=template&id=2dc09a2a&scoped=true"
import script from "./bingtu.vue?vue&type=script&lang=js"
export * from "./bingtu.vue?vue&type=script&lang=js"

import "./bingtu.vue?vue&type=style&index=0&id=2dc09a2a&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc09a2a"]])

export default __exports__